// ===== INSTALAÇÃO DO APLICATIVO (PWA) =====
let deferredInstallPrompt=null;
const isStandaloneApp=()=>window.matchMedia('(display-mode: standalone)').matches||window.navigator.standalone===true;
function updateInstallAppButton(){
  const btn=document.getElementById('install-app-btn');
  if(btn) btn.style.display=isStandaloneApp()?'none':'inline-flex';
}
window.addEventListener('beforeinstallprompt',event=>{
  event.preventDefault();
  deferredInstallPrompt=event;
  updateInstallAppButton();
});
window.addEventListener('appinstalled',()=>{
  deferredInstallPrompt=null;
  updateInstallAppButton();
  toast('Aplicativo instalado ✅');
});
async function installApp(){
  if(deferredInstallPrompt){
    deferredInstallPrompt.prompt();
    await deferredInstallPrompt.userChoice;
    deferredInstallPrompt=null;
    updateInstallAppButton();
    return;
  }
  const isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
  const isAndroid=/Android/.test(navigator.userAgent);
  let html='';
  if(isiOS){
    html=`<div style="text-align:center;padding:8px 0">
      <div style="font-size:48px;margin-bottom:12px">📱</div>
      <div style="font-size:15px;font-weight:600;margin-bottom:16px">Instalar no iPhone / iPad</div>
      <div style="background:var(--surface2);border-radius:10px;padding:14px;text-align:left;display:flex;flex-direction:column;gap:12px">
        <div style="display:flex;align-items:center;gap:10px"><span style="font-size:22px">1️⃣</span><span>Toque em <b>Compartilhar</b> <span style="font-size:18px">⎙</span> na barra do Safari</span></div>
        <div style="display:flex;align-items:center;gap:10px"><span style="font-size:22px">2️⃣</span><span>Role para baixo e toque em <b>Adicionar à Tela de Início</b></span></div>
        <div style="display:flex;align-items:center;gap:10px"><span style="font-size:22px">3️⃣</span><span>Toque em <b>Adicionar</b> — o ícone aparece como app!</span></div>
      </div>
      <div style="margin-top:14px;font-size:12px;color:var(--muted)">⚠️ Use o Safari (não Chrome) para instalar no iOS</div>
    </div>`;
  }else{
    html=`<div style="text-align:center;padding:8px 0">
      <div style="font-size:48px;margin-bottom:12px">💻</div>
      <div style="font-size:15px;font-weight:600;margin-bottom:16px">Instalar no PC ou Android</div>
      <div style="background:var(--surface2);border-radius:10px;padding:14px;text-align:left;display:flex;flex-direction:column;gap:12px">
        <div style="display:flex;align-items:center;gap:10px"><span style="font-size:22px">1️⃣</span><span>No <b>Chrome ou Edge</b>, clique nos <b>3 pontos</b> (⋮) no canto superior direito</span></div>
        <div style="display:flex;align-items:center;gap:10px"><span style="font-size:22px">2️⃣</span><span>Escolha <b>Instalar aplicativo</b> ou <b>Adicionar à tela inicial</b></span></div>
        <div style="display:flex;align-items:center;gap:10px"><span style="font-size:22px">3️⃣</span><span>Confirme — o app abre em janela própria sem barra do navegador</span></div>
      </div>
      ${isAndroid?'<div style="margin-top:14px;font-size:12px;color:var(--muted)">Use o Chrome para instalar no Android</div>':''}
    </div>`;
  }
  // Mostra modal com as instruções
  const m=document.createElement('div');
  m.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.75);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box';
  m.innerHTML=`<div style="background:#1a1f2e;border-radius:16px;padding:24px;max-width:400px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,.7);position:relative;z-index:100000;box-sizing:border-box">
    ${html}
    <button onclick="document.getElementById('_install-modal').remove()" class="btn btn-primary" style="width:100%;margin-top:20px">Entendi!</button>
  </div>`;
  m.id='_install-modal';
  document.body.appendChild(m);
  m.addEventListener('click',e=>{if(e.target===m)m.remove()});
}
window.addEventListener('DOMContentLoaded',updateInstallAppButton);

